import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useTranslation } from 'react-i18next';
import { goToThemesEditor } from '../../../../../../../../utils/app-embed/appsEmbedIntegrationUtils';
import { SettingsWrapper } from '../../../settings-wrapper/SettingsWrapper';
import { hasAppsEmbedBlock } from '../../integrationStatusUtils';

export const AppsEmbedIntegration = ({
    themeAppExtension,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: AppsEmbedIntegrationProps) => {
    const { t } = useTranslation();

    const hasPickupAppEmbedBlock = hasAppsEmbedBlock(themeAppExtension);

    const previewStoreAppEmbedBlock = () => {
        open(`shopify://admin/themes/current/editor?context=apps&template=index`, '_blank');
    };

    const handleAddStoreAppBlock = () => {
        handleClickAddStoreAppBlock?.();
        goToThemesEditor();
    };

    return (
        <SettingsWrapper
            title={t('DASHBOARD.APP_EXTENSIONS.APPS_EMBED_INTEGRATION.TITLE')}
            badge={
                <s-badge tone={hasPickupAppEmbedBlock ? 'success' : undefined}>
                    {hasPickupAppEmbedBlock
                        ? t('DASHBOARD.APP_EXTENSIONS.ACTIVE')
                        : t('DASHBOARD.APP_EXTENSIONS.INACTIVE')}
                </s-badge>
            }
            description={
                hasPickupAppEmbedBlock
                    ? t('DASHBOARD.APP_EXTENSIONS.APPS_EMBED_INTEGRATION.ACTIVE')
                    : t('DASHBOARD.APP_EXTENSIONS.APPS_EMBED_INTEGRATION.INACTIVE')
            }
            actions={
                <s-button
                    variant="secondary"
                    onClick={hasPickupAppEmbedBlock ? previewStoreAppEmbedBlock : handleAddStoreAppBlock}
                >
                    {hasPickupAppEmbedBlock
                        ? t('DASHBOARD.APP_EXTENSIONS.APPS_EMBED_INTEGRATION.ACTIONS.APP_EMBED_SETTINGS')
                        : t('DASHBOARD.APP_EXTENSIONS.APPS_EMBED_INTEGRATION.ACTIONS.ADD_EMBED_APP')}
                </s-button>
            }
            notificationBanner={
                hasPickupAppEmbedBlock ? null : (
                    <s-banner tone="warning">
                        {t('DASHBOARD.APP_EXTENSIONS.APPS_EMBED_INTEGRATION.INACTIVE_DESCRIPTION')}
                    </s-banner>
                )
            }
            isLoading={isLoading}
            condensed={condensed}
        />
    );
};

interface AppsEmbedIntegrationProps {
    themeAppExtension: ExtensionInfo;
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
